import React from 'react';
import './unlockedcharacter.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic50 from '../assets/pic50.png'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import pic54 from '../assets/pic54.png'
import pic57 from '../assets/pic57.png'
import pic58 from '../assets/pic58.png'
import pic59 from '../assets/pic59.png'
import pic60 from '../assets/pic60.png'
import pic61 from '../assets/pic61.png'
import pic62 from '../assets/pic62.png'
import pic63 from '../assets/pic63.png'
import pic64 from '../assets/pic64.png'
import pic67 from '../assets/pic67.png'
import pic68 from '../assets/pic68.png'
import pic69 from '../assets/pic69.png'
import pic70 from '../assets/pic70.png'
import pic71 from '../assets/pic71.png'
import pic72 from '../assets/pic72.png'
import pic73 from '../assets/pic73.png'
import pic81 from '../assets/pic81.png'
import pic74 from '../assets/pic74.png'
import pic75 from '../assets/pic75.png'
import pic76 from '../assets/pic76.png'
import pic77 from '../assets/pic77.png'
import pic78 from '../assets/pic78.png'
import pic79 from '../assets/pic79.png'
import pic80 from '../assets/pic80.png'
import AudioContext from '../components/common/AudioContext';
import './howtoplayinstructions.css'
import Winingaudio from '../audio/Wining.mp3'
import './howtoplayinstructions.css'
import { useNavigate } from 'react-router-dom';
import pic103 from '../assets/pic103.png'
import pic110 from '../assets/pic110.png'
import Primaryctashort from '../components/common/primaryshortcta';
import Secondaryctashort from '../components/common/secondaryshort';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import pic146 from '../assets/pic146.png'
import pic177 from '../assets/pic177.png'
import pic223 from '../assets/pic223.png'

import pic49 from '../assets/pic49.png';
import pic239 from '../assets/pic239.png';
import pic232 from '../assets/pic232.png';
import pic235 from '../assets/pic235.png';

const Unlocknewcharacter = () => {
 const [settingsOpen, setSettingsOpen] = useState(false);
    const { soundVolume } = React.useContext(AudioContext);
    const audioRef = React.useRef(null);
    const [closing, setClosing] = useState(false);
     const navigate = useNavigate();
     const [nexting, setNexting] = useState(false);
     const location = useLocation();
        const score = location.state?.score || 0;
        const lives = location.state?.lives || 0;
        const collected = location.state?.collected || 0;
        const starCount = location.state?.starCount || 0;
        const level = location.state?.level || 1;

        const levelBackgrounds = {
                  1: pic49,
                  2: pic239,
                  3: pic232,
                  4: pic235
              };
      
              const currentBackground = levelBackgrounds[level];      

    const level1Stars = location.state?.level1Stars || 0;
    const level2Stars = location.state?.level2Stars || 0;

    useEffect(() => {
    const seenKey =
        level === 1 ? 'character2UnlockSeen'
        : level === 3 ? 'character4UnlockSeen'
        : level === 4 ? 'character5UnlockSeen'
        : 'character3UnlockSeen';
    localStorage.setItem(seenKey, 'true');
}, [level]);

    useEffect(() => {
            const audio = audioRef.current;
            if (!audio) return;
            audio.volume = soundVolume;
            audio.play().catch(() => {});

            return () => {
                audio.pause();
                audio.currentTime = 0;
            };
        }, []);

        useEffect(() => {
            if (audioRef.current) audioRef.current.volume = soundVolume;
        }, [soundVolume]);


        const handleBack = () => {
            setClosing(true);

            setTimeout(() => {
                navigate('/Wining', {
                    state: {
                        score,
                        lives,
                        collected,
                        starCount,
                        level
                    }
                });
            }, 400);
        };

            const handleNext = () => {
                setNexting(true);

                setTimeout(() => {
                    navigate(
                        level === 4
                        ? '/level5unlocked'
                       : level === 3
                        ? '/level4unlocked'
                       : level === 1
                            ? '/level2unlocked'
                            : '/level3unlocked',
                        {
                            state: {
                                score,
                                lives,
                                collected,
                                starCount,
                                level,
                                level1Stars,
                                level2Stars
                            }
                        }
                    );
                }, 400);
            };

    return ( 
        <>
             {closing && <div className='story-bg-behind' />}
<main className='level1--page '>
            <section className='levelbackground--page '>
                 <audio ref={audioRef} src={Winingaudio} preload="auto" />
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
                <>

               <section className='settings-background '>
               <section  className={`unlocked-character-overlay-inst ${nexting ? 'slide-down' : 'slide-up'}`}>
                <section className='header-losing-overlay-unlocked-cha'>
                    <div className='header-title-cont-unlocked-char'>
                        <h2 className='title-containerr-unlocked-ch'>Character <br /> Unlocked</h2>
                        <h2 className='title2-container-settings2'>Character <br /> Unlocked</h2>
                    </div>
                    
                </section>


                <section className='container-unlocked-new-char'>
               
                            <h2 className='title-losing'>
                                {
                               level === 4
                               ? 'Mariam Lotus'
                               : level === 3
                                     ? 'Ahmad Amon'
                               : level === 1 
                                ? 'Sarah Idress' 
                                : 'Teyah Ramses'}
                            </h2>
                             {/* <img className='img-unlocked-new-char' 
                             src={pic110} alt='character-unlocked'></img> */}
                            <img
                                className='img-unlocked-new-char'
                                src={
                                    level === 4
                                     ? pic223
                                   : level === 3
                                     ? pic177
                                   : level === 1 
                                    ? pic110 
                                    : pic146}
                                alt='character-unlocked'
                            />


                            <div className='container-continue-unlock-char' >
                                <div onClick={handleBack}>
                                    <Secondaryctashort  title='Back'/>
                                </div>
                                <div onClick={handleNext}>
                                <Primaryctashort title='Claim' />
                                </div>
                            
                            </div>




                </section>

                </section>
                  <img className='decoration' src={pic103} alt='decoration'></img>
            </section>
          
           
        </>
               <div  className='background-and-obstacles-lose'
                        style={{
                            '--level-bg': `url(${currentBackground})`
                        }}
                        >
                    <div className='container-obtsacles-and-collections'>
                        <img className='obstacle1' src={pic57} alt='obstacle-1'/>
                        <img className='obstacle2' src={pic58} alt='obstacle-2'/>
                        <img className='obstacle3' src={pic59} alt='obstacle-3'/>
                        <img className='obstacle4' src={pic60} alt='obstacle-4'/>
                        <img className='obstacle5' src={pic61} alt='obstacle-5'/>
                        <img className='collect1' src={pic62} alt='collect-1'/>  
                        <img className='obstacle6' src={pic63} alt='obstacle-6'/>  
                        <img className='obstacle7' src={pic64} alt='obstacle-7'/>   
                        <img className='obstacle8' src={pic67} alt='obstacle-8'/>                          
                        <img className='obstacle9' src={pic68} alt='obstacle-9'/>  
                        <img className='obstacle10' src={pic69} alt='obstacle-10'/>  
                        <img className='obstacle11' src={pic70} alt='obstacle-11'/>  
                        <img className='obstacle12' src={pic71} alt='obstacle-12'/>  
                        <img className='obstacle13' src={pic72} alt='obstacle-12'/> 
                        <img className='obstacle14' src={pic73} alt='obstacle-14'/> 
                        <img className='obstacle15' src={pic81} alt='obstacle-14'/> 
                        <img className='obstacle16' src={pic74} alt='obstacle-14'/> 
                        <img className='obstacle17' src={pic75} alt='obstacle-17'/> 
                        <img className='obstacle18' src={pic76} alt='obstacle-18'/> 
                        <img className='obstacle19' src={pic77} alt='obstacle-19'/>  
                        <img className='obstacle20' src={pic78} alt='obstacle-20'/>                            
                        <img className='obstacle21' src={pic79} alt='obstacle-20'/> 
                        <img className='obstacle22' src={pic80} alt='obstacle-20'/> 

                    </div>
                </div>

   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                    title={`Level ${level}`}
                    title2={`Level ${level}`}
                    link='/home'  onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon'
                    img2={pic11} icontext2='settings icon'/>
                 <img className='character-movement' src={pic54} alt='character'></img>




                    <div className='HUD-container'>

                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    <div className='img-container-HUD'> 
                                        <img src={pic50} alt='collect-item-1'></img>
                                    </div>

                                    <div className='img-container-HUD'> 
                                        <img src={pic51} alt='collect-item-1'></img>
                                    </div>


                                    <div className='img-container-HUD'> 
                                        <img src={pic52} alt='collect-item-1'></img>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>

         </>
     );
}
 
export default Unlocknewcharacter;